export default class BgColorChange {
    constructor(){
        //if($('body#top')[0]) $('#l-header').addClass('transparent');
        $('#l-header').addClass('color');
    }
    update(scr,kvH,hH){
        // if(!$('#l-kv')[0]||$("#l-header__btn-online__list").hasClass('open')||$("#l-header__btn-store__list").hasClass('open')||$("#l-header__navi").hasClass('open')) return false;
        // if(scr > kvH - hH){
        //     $('#l-header').removeClass('transparent').addClass('color');
        // }else{
        //     $('#l-header').addClass('transparent').removeClass('color');
        // }

    }
}